
import { MoreHorizontal, Share2, Trash2 } from "lucide-react";
import relativeTime from "dayjs/plugin/relativeTime";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import "./anokye-list.css";
import { useChatContext } from "@/services/chat-provider";

export default function AnokyeList({ projects, onDeleteProject, onShareProject }) {
  const { useActiveProjectId } = useChatContext()

  const [_, setActiveProjectId] = useActiveProjectId()
  const history = useHistory();
  const [openMenuId, setOpenMenuId] = useState(null);
  dayjs.extend(relativeTime);

  function handleSelectProject(project) {
    setActiveProjectId(project?._id);
    history.replace("/");
  }

  function toggleMenu(e, id) {
    e.stopPropagation();
    setOpenMenuId(openMenuId === id ? null : id);
  }

  function handleShare(e, project) {
    e.stopPropagation();
    if (onShareProject) onShareProject(project);
    setOpenMenuId(null);
  }

  function handleDelete(e, id) {
    e.stopPropagation();
    if (onDeleteProject) onDeleteProject(id);
    setOpenMenuId(null);
  }

  // Close menu on click outside
  useEffect(() => {
    const handleClickOutside = () => setOpenMenuId(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="anokye__list-container">
      <div className="anokye__list-header">
        <div className="anokye__list-col-title">Project Name</div>
        <div className="anokye__list-col-updated">Last Activity</div>
        <div className="anokye__list-col-created">Created At</div>
        <div className="anokye__list-col-actions"></div>
      </div>
      <div className="anokye__list-body">
        {projects.map((project) => (
          <div
            key={project?._id}
            className="anokye__list-row"
            onClick={() => handleSelectProject(project)}
          >
            <div className="anokye__list-col-title">
              <span className="anokye__project-name">{project?.title}</span>
            </div>
            <div className="anokye__list-col-updated">
              <time dateTime={project?.updatedAt}>
                {dayjs().to(dayjs(project?.updatedAt))}
              </time>
            </div>
            <div className="anokye__list-col-created">
              <time dateTime={project?.createdAt}>
                {dayjs().to(dayjs(project?.createdAt))}
              </time>
            </div>
            <div className="anokye__list-col-actions">
              <div className="anokye__grid-item-menu-container">
                <button
                  className="anokye__grid-item-menu-btn"
                  onClick={(e) => toggleMenu(e, project?._id)}
                >
                  <MoreHorizontal size={18} />
                </button>

                {openMenuId === project?._id && (
                  <div className="anokye__grid-item-dropdown">
                    <button
                      className="anokye__project-dropdown-item"
                      onClick={(e) => handleShare(e, project)}
                    >
                      <Share2 size={14} />
                      <span>Share</span>
                    </button>
                    {/* <button
                      className="anokye__project-dropdown-item danger divider-top"
                      onClick={(e) => handleDelete(e, project?._id)}
                    >
                      <Trash2 size={14} />
                      <span>Delete</span>
                    </button> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
